import React from 'react'
import { FooterComponent, NavbarComponent } from '../../SharedComponents'
import BackToNatureSection from '../SustainabilityPage/BackToNatureSection'
import TitleSection from './TitleSection'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Section5 from './Section5'
import Section6 from './Section6'
import Section7 from './Section7'
import Section8 from './Section8'
import './BrandsPage.css'

export default function BrandsPage() {
    return (
        <div>
            <NavbarComponent />
            <TitleSection />
            <Section1 />
            <Section2 />
            <Section3 />
            <Section4 />
            <Section5 />
            <Section6 />
            <Section7 />
            <Section8 />
            <BackToNatureSection />
            <FooterComponent />
        </div>
    )
}
